import { render, staticRenderFns } from "./BpTag.vue?vue&type=template&id=1b2e7425&"
import script from "./BpTag.vue?vue&type=script&lang=js&"
export * from "./BpTag.vue?vue&type=script&lang=js&"
import style0 from "./BpTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports